export default __webpack_public_path__ + "static/media/about-sec-img.609a8683.png";